<template>
  <div>
    <v-container v-show="!isFarmAvailable && myloadingvariable">
      <v-dialog v-model="alert.type" max-width="390" transition="scale-transition">
        <v-card>
          <v-card-title :class="alert.color">
            {{ alert.title }}
          </v-card-title>

          <v-card-text>
            {{ alert.message }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="alert.type = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card class="ma-3">
        <v-card-title>
          Farm Details
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="farm_data" :search="search">
          <template v-slot:[`item.current_date`]="{ item }">
            {{ formatDate(item.current_date) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small class="ma-2 primary--text" outlined @click="dialogFarmItem(item)">
              View Stages
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-container v-if="isFarmAvailable">
      <v-btn class="my-5" color="primary" @click="isFarmAvailable = false" dark large top left>
        Go Back
      </v-btn>
      <template>
        <v-container fluid>
          <v-row justify="end">
            <v-expansion-panels>
              <v-expansion-panel hide-actions eager="true" v-for="(cy_data, j) in farm" :key="j">
                <v-expansion-panel-header @click="modalShown1(`mymap` + j)">
                  <v-row align="center" class="spacer" no-gutters>
                    <v-col cols="4" sm="2" md="1">
                      <v-avatar size="36px">
                        <v-icon color="orange">{{ getStageIcon(cy_data.caption) }}</v-icon>
                      </v-avatar>
                    </v-col>

                    <v-divider vertical></v-divider>
                    <v-col cols="1" sm="1" md="1"> </v-col>
                    <v-col cols="4" sm="3" md="3">
                      <strong>{{ cy_data.caption }}</strong>
                    </v-col>

                    <v-col class="hidden-xs-only" sm="5" md="3">
                      <strong>{{ formatDate(cy_data.current_date) }}</strong>
                    </v-col>

                    <v-col class="grey--text text-truncate hidden-sm-and-down ma-2"> </v-col>
                  </v-row>
                </v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-divider></v-divider>
                  <v-container class="pa-5">
                    <v-row dense>
                      <v-col class="col-md-12 col-sm-12 ">
                        <v-card class="mx-auto pa-5" outlined>
                          <v-row>
                            <!-- Check -->

                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.name">
                              <v-text-field outlined label="Name" readonly="true"
                                :value="cy_data.details.name"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.mobile">
                              <v-text-field outlined label="Mobile" readonly="true"
                                :value="cy_data.details.mobile"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.village">
                              <v-text-field outlined label="Village" readonly="true"
                                :value="cy_data.details.village"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.district">
                              <v-text-field outlined label="District" readonly="true"
                                :value="cy_data.details.district"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.pin">
                              <v-text-field outlined label="PIN" readonly="true"
                                :value="cy_data.details.pin"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.total_acre">
                              <v-text-field outlined label="Total acre" readonly="true"
                                :value="cy_data.details.total_acre"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary" v-if="cy_data.details.dealer">
                              <v-text-field outlined label="Dealer" readonly="true"
                                :value="cy_data.details.dealer"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.farm_id">
                              <v-text-field outlined label="Field ID" readonly="true"
                                :value="cy_data.details.farm_id"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.acre">
                              <v-text-field outlined label="Area" readonly="true"
                                :value="cy_data.details.acre"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.village">
                              <v-text-field outlined label="Village" readonly="true"
                                :value="cy_data.details.village"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.irrigation">
                              <v-text-field outlined label="Irrigation" readonly="true"
                                :value="cy_data.details.irrigation"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seed_type">
                              <v-text-field outlined label="Seed Type" readonly="true"
                                :value="cy_data.details.seed_type"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="cy_data.details.north || cy_data.details.east">
                            <v-col class="col-md-3 col-sm-12 text--secondary">Near by plots </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.north">
                              <v-text-field outlined label="North" readonly="true"
                                :value="cy_data.details.north"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.east">
                              <v-text-field outlined label="East" readonly="true"
                                :value="cy_data.details.east"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.south">
                              <v-text-field outlined label="South" readonly="true"
                                :value="cy_data.details.south"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.west">
                              <v-text-field outlined label="West" readonly="true"
                                :value="cy_data.details.west"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details_id">
                              <v-text-field outlined label="Field ID" readonly="true"
                                :value="cy_data.details_id"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.previous_cultivation">
                              <v-text-field outlined label="Previous Cultivation" readonly="true"
                                :value="cy_data.details.previous_cultivation"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.soil_type">
                              <v-text-field outlined label="Soil type" readonly="true"
                                :value="cy_data.details.soil_type"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.soil_test_date">
                              <v-text-field outlined label="Soil test date" readonly="true"
                                :value="formatDate(cy_data.details.soil_test_date)"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.result">
                              <v-text-field outlined label="Result" readonly="true"
                                :value="cy_data.details.result"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.cultivation_variety">
                              <v-text-field outlined label="Cultivation variety" readonly="true"
                                :value="cy_data.details.cultivation_variety"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.estimated_harvest">
                              <v-text-field outlined label="Estimated harvest" readonly="true"
                                :value="cy_data.details.estimated_harvest"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.mode">
                              <v-text-field outlined label="Mode" readonly="true"
                                :value="cy_data.details.mode"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.transplant_date">
                              <v-text-field outlined label="Transplant date" readonly="true"
                                :value="formatDate(cy_data.details.transplant_date)"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.space_btn_r_to_r">
                              <v-text-field outlined label="Space between R to R" readonly="true"
                                :value="cy_data.details.space_btn_r_to_r"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.space_btn_p_to_p">
                              <v-text-field outlined label="Space between P to P" readonly="true"
                                :value="cy_data.details.space_btn_p_to_p"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.mode_of_application">
                              <v-text-field outlined label="Mode of application" readonly="true"
                                :value="cy_data.details.mode_of_application"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.dosage_plant_growth">
                              <v-text-field outlined label="Dosage" readonly="true"
                                :value="cy_data.details.dosage_plant_growth"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.chemical_name_fertilizer">
                              <v-text-field outlined label="Chemical name" readonly="true"
                                :value="cy_data.details.chemical_name_fertilizer"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.npk_percentage">
                              <v-text-field outlined label="NPK Percentage" readonly="true"
                                :value="cy_data.details.npk_percentage"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.disease_type">
                              <v-text-field outlined label="Disease type" readonly="true"
                                :value="cy_data.details.disease_type"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.dosage_pesticides">
                              <v-text-field outlined label="Dosage" readonly="true"
                                :value="cy_data.details.dosage_pesticides"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.chemical_name_pesticides">
                              <v-text-field outlined label="Chemical name" readonly="true"
                                :value="cy_data.details.chemical_name_pesticides"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.brand">
                              <v-text-field outlined label="Brand" readonly="true"
                                :value="cy_data.details.brand"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.sampler_id">
                              <v-text-field outlined label="Sample id" readonly="true"
                                :value="cy_data.details.sampler_id"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.sampler_name">
                              <v-text-field outlined label="Sample name" readonly="true"
                                :value="cy_data.details.sampler_name"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.expected_overall_yield">
                              <v-text-field outlined label="Expected overall yield" readonly="true"
                                :value="cy_data.details.expected_overall_yield"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.plucking_quantity">
                              <v-text-field outlined label="Plucking quantity" readonly="true"
                                :value="cy_data.details.plucking_quantity"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary "
                              v-if="cy_data.details.plucking_number && cy_data.caption != 'Farm'">
                              <v-text-field outlined label="Plucking number" readonly="true"
                                :value="cy_data.details.plucking_number"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.plucking_date">
                              <v-text-field outlined label="Plucking date" readonly="true"
                                :value="formatDate(cy_data.details.plucking_date)"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.lot_id">
                              <v-text-field outlined label="LOT ID" readonly="true"
                                :value="cy_data.details.lot_id"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.color_tag">
                              <v-text-field outlined label="Color Tag" readonly="true"
                                :value="cy_data.details.color_tag"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.final_quantity">
                              <v-text-field outlined label="Final Quantity" readonly="true"
                                :value="cy_data.details.final_quantity"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.number_of_bags">
                              <v-text-field outlined label="Number of bags" readonly="true"
                                :value="cy_data.details.number_of_bags"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.harvest_date">
                              <v-text-field outlined label="Harvest date" readonly="true"
                                :value="formatDate(cy_data.details.harvest_date)"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.medium_of_drying">
                              <v-text-field outlined label="Medium of drying" readonly="true"
                                :value="cy_data.details.medium_of_drying"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.truck_number">
                              <v-text-field outlined label="Truck number" readonly="true"
                                :value="cy_data.details.truck_number"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.driver_name">
                              <v-text-field outlined label="Driver name" readonly="true"
                                :value="cy_data.details.driver_name"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.driver_mobile">
                              <v-text-field outlined label="Driver mobile" readonly="true"
                                :value="cy_data.details.driver_mobile"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seal_no_1">
                              <v-text-field outlined label="Seal Number 1" readonly="true"
                                :value="cy_data.details.seal_no_1"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seal_no_2">
                              <v-text-field outlined label="Seal Number 2" readonly="true"
                                :value="cy_data.details.seal_no_2"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seal_no_3">
                              <v-text-field outlined label="Seal Number 3" readonly="true"
                                :value="cy_data.details.seal_no_3"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seal_no_4">
                              <v-text-field outlined label="Seal Number 4" readonly="true"
                                :value="cy_data.details.seal_no_4"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seal_no_5">
                              <v-text-field outlined label="Seal Number 5" readonly="true"
                                :value="cy_data.details.seal_no_5"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.seal_no_6">
                              <v-text-field outlined label="Seal Number 6" readonly="true"
                                :value="cy_data.details.seal_no_6"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.details.security_pin">
                              <v-text-field outlined label="Security PIN" readonly="true"
                                :value="cy_data.details.security_pin"></v-text-field>
                            </v-col>
                            <!-- End check -->
                            <v-col v-if="cy_data.details.crop_condition" class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Crop Condition" readonly="true"
                                :value="cy_data.details.crop_condition"></v-text-field>
                            </v-col>

                            <v-col v-if="cy_data.details.content" class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Content" readonly="true"
                                :value="cy_data.details.content"></v-text-field>
                            </v-col>
                            <v-col v-if="cy_data.details.dosage_plant_growth"
                              class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Dosage" readonly="true"
                                :value="cy_data.details.dosage_plant_growth"></v-text-field>
                            </v-col>
                            <v-col v-if="cy_data.details.chemical_name_plant_growth"
                              class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Chemical name" readonly="true"
                                :value="cy_data.details.chemical_name_plant_growth"></v-text-field>
                            </v-col>
                            <v-col v-if="cy_data.details.next_visit" class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Next Visit" readonly="true"
                                :value="formatDate(cy_data.details.next_visit)"></v-text-field>
                            </v-col>
                            <v-col v-if="cy_data.reason" class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Reson" readonly="true"
                                :value="cy_data.reason"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.remarks">
                              <v-text-field outlined label="Remarks" readonly="true"
                                :value="cy_data.remarks"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row v-if="cy_data.cycle_type === 'fertilizer'">
                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Field ID" readonly="true"
                                :value="cy_data.farm_id"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Crop Condition" readonly="true"
                                :value="cy_data.details.crop_condition"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Mode of application" readonly="true"
                                :value="cy_data.details.mode_of_application"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Dosage" readonly="true"
                                :value="cy_data.details.dosage_plant_growth"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Chemical name" readonly="true"
                                :value="cy_data.details.chemical_name_fertilizer"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="NPK Percentage" readonly="true"
                                :value="cy_data.details.npk_percentage"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Next Visit" readonly="true"
                                :value="formatDate(cy_data.details.next_visit)"></v-text-field>
                            </v-col>

                            <v-col class="col-md-3 col-sm-12 text--secondary ">
                              <v-text-field outlined label="Reson" readonly="true"
                                :value="cy_data.reason"></v-text-field>
                            </v-col>
                            <v-col class="col-md-3 col-sm-12 text--secondary " v-if="cy_data.remarks">
                              <v-text-field outlined label="Remarks" readonly="true"
                                :value="cy_data.remarks"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col class="col-md-12 col-sm-12">
                        <v-card outlined>
                          <v-row>
                            <v-col class="col-md-6 col-sm-12">
                              <v-carousel class="ma-5 mx-auto" eager="true">
                                <v-btn class="rotate" depressed color="primary" @click="rotateRight">
                                  Rotate
                                </v-btn>
                                <v-carousel-item v-for="(item, i) in cy_data.images" :key="i"
                                  reverse-transition="fade-transition" transition="fade-transition">
                                  <v-img height="100%" width="100%" :src="getImage(item.label)" contain
                                    :style="`transform: rotate(${rotate}deg);`">
                                  </v-img>
                                </v-carousel-item>
                              </v-carousel>
                            </v-col>

                            <v-col class="col-md-6 col-sm-12">
                              <template>
                                <v-card class="ma-5" outlined>
                                  <div class="foobar1">
                                    <!-- eager="true" -->
                                    <l-map :zoom="zoom" :center="getMapCenter(cy_data.location)" :ref="`mymap` + j"
                                      style="height:500px; width: 100%">
                                      <l-tile-layer :url="url" />
                                      <l-marker :lat-lng="getLocation(cy_data.location)">
                                        <l-tooltip :options="{
                                          permanent: true,
                                          interactive: true,
                                        }">
                                          <div>Updated Location</div>
                                        </l-tooltip>
                                      </l-marker>
                                      <l-icon-default :image-path="iconUrl" />

                                      <l-polygon :lat-lngs="getPoligonLocations(plot_marks)" color="red">
                                        <l-popup content="Plot" />
                                      </l-polygon>
                                    </l-map>
                                  </div>
                                </v-card>
                              </template>
                            </v-col>

                            <!-- <v-col class="col-md-6 col-sm-12" v-else>
                              <template>
                                <v-card class="ma-5" outlined>
                                  <div class="footer1">
                                    <l-map
                                      :ref="`mymap` + j"
                                      :zoom="zoom"
                                      :center="getMapCenter(cy_data.location)"
                                      style="height:500px; width: 100%"
                                    >
                                      <l-tile-layer :url="url" />
                                      <l-marker
                                        :lat-lng="getLocation(cy_data.location)"
                                      >
                                        <l-tooltip
                                          :options="{
                                            permanent: true,
                                            interactive: true,
                                          }"
                                        >
                                          <div>Updated Location</div>
                                        </l-tooltip>
                                      </l-marker>
                                      <l-icon-default :image-path="iconUrl" />
                                    </l-map>
                                  </div>
                                </v-card>
                              </template>
                            </v-col> -->
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
      </template>
    </v-container>
    <v-container class="indicator" v-if="!myloadingvariable">
      <v-progress-circular :size="50" :width="5" color="orange" indeterminate></v-progress-circular>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPolygon, LPopup, LTooltip } from "vue2-leaflet";

// import { gmapsMap, gmapsMarker } from "x5-gmaps";
import { apiLink } from "../config";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LPopup,
    LTooltip,
  },
  data() {
    return {
      // map
      zoom: 18,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      //   marker: latLng(47.41322, -1.219482),

      search: "",
      plot_marks: [],
      myloadingvariable: false,
      alert: {
        color: "info",
        title: null,
        message: null,
        type: null,
      },
      rotate: 0,
      headers: [
        {
          text: "Farm registered date",
          align: "start",
          sortable: true,
          value: "current_date",
        },
        {
          text: "Staff Name",
          align: "start",
          sortable: true,
          value: "user_name",
        },
        {
          text: "Field ID",
          align: "start",
          sortable: true,
          value: "farm_id",
        },
        {
          text: "Farmer ID",
          align: "start",
          sortable: true,
          value: "farmer_id",
        },
        {
          text: "Farmer Name",
          align: "start",
          sortable: true,
          value: "farmer[0].name",
        },
        { text: "Village", value: "farmer[0].village", sortable: true },
        { text: "Actions", align: "end", value: "actions", sortable: false },
      ],
      farm_data: [],
      isFarmAvailable: false,
      farm: [],
      stageIcons: [
        { caption: "Farmer", icon: "directions_run" },
        { caption: "Farm", icon: "emoji_nature" },
        { caption: "Soil Analysis", icon: "blur_on" },
        { caption: "Sowing", icon: "blur_linear" },
        { caption: "Planting", icon: "agriculture" },
        { caption: "Pesticides", icon: "pest_control" },
        { caption: "Fertilizer", icon: "coronavirus" },
        { caption: "Plant Growth Regulator", icon: "show_chart" },
        { caption: "QC Sampling", icon: "transfer_within_a_station" },
        { caption: "Post Harvest", icon: "filter_vintage" },
        { caption: "Truck", icon: "local_shipping" },
        { caption: "General Visit", icon: "verified" },
      ],
      seasons: {
        items: [],
        selected: null,
      },
    };
  },
  created() {
    this.initialize();

    const savedFarmId = localStorage.getItem('backup_farm_id');
    if (savedFarmId) {
      // Run a slight timeout to ensure initialize() and seasons are set first
      setTimeout(() => {
        this.dialogFarmItem({ farm_id: savedFarmId });
      }, 500);
    }
  },

  mounted() {
    this.$refs.mymap.mapObject._onResize();
  },
  methods: {
    initialize() {
      axios
        .get("farm/all")
        .then((res) => {
          this.farm_data = res.data;
          this.myloadingvariable = true;
        })
        .catch((err) => {
          console.log(err);
        });
      this.getAllSeasons();
    },
    rotateRight() {
      console.log(this.rotate);
      this.rotate -= 90;
    },

    modalShown1(j) {
      this.rotate = 0;
      let refMap = j;
      console.log(refMap);
      setTimeout(() => {
        this.$refs[j][0].mapObject.invalidateSize();
      }, 100);
    },

    async getAllSeasons() {
      await axios
        .get(`/active-year?sort=id%2CASC`)
        .then(async (res) => {
          //console.log(res.data.filter((season) => season.active_status == true));
          this.seasons.items = res.data;
          this.seasons.selected = res.data.filter((season) => season.active_status == true)[0];
        })
        .catch((err) => console.log(err))
    },

    async dialogFarmItem(item) {
      localStorage.setItem('backup_farm_id', item.farm_id);

      await axios
        .get(`/farm/crop-stage-by-farm/${item.farm_id}?active_year_id=${this.seasons.selected.id}`)
        .then((res) => {
          this.farm = res.data;

          if (res.data.length > 0) {
            this.isFarmAvailable = true;
          } else {
            this.alert.color = "red--text";
            this.alert.title = "Sorry";
            this.alert.message = "No Crop stage found for selected Farm";
            this.alert.type = true;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setPlotMarks();
        });

      this.dialogMap = false;
    },
    async setPlotMarks() {
      // plot_marks
      let farm_data = this.farm.filter((item) => {
        if (item.caption === "Farm") {
          return item;
        }
      });

      this.plot_marks = farm_data[0].details.plot_marks;
    },

    formatDate(date) {
      let monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      //  month = "" + (d.getMonth() + 1),
      var d = new Date(date),
        month = "" + monthNames[d.getMonth()],
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // var d = dateVar.add(-1).day().toString('dd-MMM-yyyy');

      return [day, month, year].join(" - ");
    },
    getImage(img) {
      let data = apiLink + "/" + img;
      console.log(data);
      return data;
    },
    getLocation(loc) {
      return latLng(loc.lat, loc.long);
    },
    getMapCenter(loc) {
      return [loc.lat, loc.long];
    },

    getPoligonLocations(plot_marks) {
      let arr = [];
      plot_marks.forEach((element) => {
        arr.push([element.lat, element.long]);
      });
      return arr;
    },
    getStageIcon(caption) {
      let data = "";
      this.stageIcons.forEach((element) => {
        if (element.caption === caption) {
          data = element.icon;
        }
      });

      return data;
    },
    modalShown() {
      setTimeout(() => {
        this.$refs.mymap.mapObject.invalidateSize();
      }, 100);
    },
    onResize() {
      this.$refs.mymap.mapObject.invalidateSize();
    },

    // map
    // end map
  },
  beforeDestroy() {
    // Clear the farm_id from localStorage
    localStorage.removeItem("backup_farm_id");
  },
};
</script>
<style>
/* @import "~leaflet/dist/leaflet.css"; */
/* @import "http://cdn.leafletjs.com/leaflet-0.7.5/leaflet.css"; */
.compact-form {
  transform: scale(0.865);
  transform-origin: center;
}
</style>
<style lang="scss">
.vue2leaflet-map {
  z-index: 1;
}

.v-stepper {
  box-shadow: none;
}

.foobar1 {
  width: 100%;
  height: 500px;
}

.v-progress-circular {
  position: absolute;
  top: 100%;
  left: 50%;
}

.indicator {
  height: 40vh;
}

.rotate {
  position: absolute;
  right: 1%;
  bottom: 1%;
  z-index: 10;
}
</style>
